import type { ReactNode } from 'react';

export const symbol_calendar_lock: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M180-80q-24 0-42-18t-18-42v-620q0-24 18-42t42-18h65v-28q0-13.6 9-22.8 9-9.2 23.02-9.2t23.5 9.2Q310-861.6 310-848v28h340v-28q0-13.6 9-22.8 9-9.2 23.02-9.2t23.5 9.2Q715-861.6 715-848v28h65q24 0 42 18t18 42v258q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-68H180v430h363q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32Q555.75-80 543-80H180Zm0-550h600v-130H180v130Zm0 0v-130 130ZM675-80q-15 0-28.5-13.5T633-122v-122q0-15 13.5-28.5T675-286v-40q0-36 23.5-61t58.5-25q35 0 58 25t23 61v40h1q14 0 27.5 13.5T880-244v122q0 15-13.5 28.5T839-80H675Zm40-206h84v-40q0-19.55-11.5-32.77Q776-372 756.5-372T726-358.77q-11 13.22-11 32.77v40Z"
		/>
	</svg>
);
